import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';
import { Params, SearchClient, SearchResponse } from '@empathybroker/tsclient-search';

import { ActionContext } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { ActionClass, ContextState, Dictionary, Filter, SearchState } from '../../../models';

import { CONFIG_CONSTS } from '../../../store/config/config.consts';
import { CONTEXT_CONSTS } from '../../../store/context/context.consts';
import { SEARCH_CONSTS } from '../../../store/search/search.consts';

import { SearchAction } from './search.action';

export class LoadAttributesAction implements ActionClass {

  public static async execute({ commit, rootGetters }: ActionContext<SearchState, any>, payload: {
    filters?: Dictionary<Filter>,
    attribute: string,
    params?: Params
  }): Promise<void> {
    const context: ContextState = rootGetters[`${ CONTEXT_CONSTS.moduleName }/${ CONTEXT_CONSTS.getters.context }`];
    const instanceConfig: Instance = rootGetters[`${ CONFIG_CONSTS.moduleName }/${ CONFIG_CONSTS.getters.currentInstance }`];
    const searchClient: SearchClient = CONTAINER.get<(context: ContextState, instanceConfig: Instance) => SearchClient>(
      TYPES.SearchClient)(context, instanceConfig);
    const searchFilters = (!!payload.filters ? SearchAction.getSearchFilters(payload.filters) : undefined);
    const params = Object.assign({}, searchFilters, payload.params);
    if (!params.lang) { // TODO load this lang from a config file
      params.lang = 'es';
    }
    try {
      const response = (await searchClient.loadAttributes(payload.attribute, params) as SearchResponse);
      commit(SEARCH_CONSTS.mutations.setAttributes, { attribute: payload.attribute, data: response.data });
    } catch (error) {
      throw error;
    }
  }
}
